import { useEffect } from 'react';
import { useDeviceWarningsStore } from './state/use-device-warnings-store';

export const useFetchDeviceWarnings = (deviceId) => {
  const fetchWarnings = useDeviceWarningsStore((state) => state.fetchWarnings);

  useEffect(() => {
    if (!deviceId) return;
    fetchWarnings(deviceId);
  }, [deviceId, fetchWarnings]);
};

export default useFetchDeviceWarnings;
